import { type SelectOption } from '@shared/ui-components';

export const getOptionByValue = <T>(options: Array<SelectOption<T>>, value: T | null | undefined) =>
  options.find((option) => option?.value === value ?? null) ?? null;
